import type { VendorMetadataExtractor, ExtractedIncidentMeta } from './types'

export const genericExtractor: VendorMetadataExtractor = {
  vendorId: null,
  vendorLabel: 'Generic / Other',
  supportsDirectoryBrowse: false,

  async extractFromFiles(files: File[]): Promise<ExtractedIncidentMeta | null> {
    const first = files[0]
    if (!first) return null
    return { dateTime: new Date(first.lastModified) }
  }
}
